import {Button, Col, Row, Table, UncontrolledCollapse} from "reactstrap";
import React from "react";


export function renderOSConf(conf){
    let filesJSX = renderFilesConfig(conf);
    let flocksJSX = renderFlocksConfig(conf);
    let signalsJSX = renderSignalsConfig(conf);
    let fifosJSX = renderFifosConfig(conf);
    let shmsJSX = renderSHMConfig(conf);

    return(
        <React.Fragment>
            {filesJSX}
            {flocksJSX}
            {signalsJSX}
            {fifosJSX}
            {shmsJSX}
        </React.Fragment>
    );
}
/*******************************************************SHMS*******************************************************/
function renderSHMConfig(OSConf){
    let setupSHMJSX = null;
    let teardownSHMJSX = null;
    if(OSConf.setup && OSConf.setup.shms){
        setupSHMJSX = [<p>Pre pokretanja programa</p>,renderSHMS(OSConf.setup.shms)];
    }
    if(OSConf.teardown && OSConf.teardown.shms){
        teardownSHMJSX = [<p>Nakon završavanja programa</p>,renderSHMS(OSConf.teardown.shms)];
    }
    let finalJSX = null;

    if(setupSHMJSX !== null){
        finalJSX = [setupSHMJSX];
        if(teardownSHMJSX !== null){
            finalJSX.push(teardownSHMJSX);
        }
    }
    else if(teardownSHMJSX !== null){
        finalJSX = [teardownSHMJSX];
    }
    else{
        return null;
    }
    return (OSConfigDisplayTemplate(
        {buttonText: "Prikaži podatke za deljenu memoriju", buttonID: "shmButtonToggler"}, finalJSX
        )
    );
}
function renderSHMS(shms) {
    if(!shms){
        return null;
    }
    const shmsJSX = shms.map(sharedMemObj=>{
        let semStartVals = sharedMemObj.semStartValues.join(", ");
        return(
            <React.Fragment>
                <Table bordered>
                    <tr>
                        <th>Naziv memorije</th>
                        <td>{sharedMemObj.name}</td>
                    </tr>
                    <tr>
                        <th>Vrednost{sharedMemObj.type.numOfShms > 1 && <text>i</text>} semafora</th>
                        <td>{semStartVals}</td>
                    </tr>
                    {sharedMemObj.type.isArray &&
                    <tr>
                        <th>Broj elemenata u nizu</th>
                        <td>{sharedMemObj.values.length}</td>
                    </tr>
                    }
                    <tr>
                        <th>Sadržaj memorije</th>
                        <td>{sharedMemObj.values.join(", ")}</td>
                    </tr>
                </Table>
            </React.Fragment>)
    });
    return(shmsJSX);
}
/******************************************************FILES******************************************************/
function renderFilesConfig(OSConf) {
    let setupFilesJSX = null;
    let teardownFilesJSX = null;
    if(OSConf.setup && OSConf.setup.files){
        setupFilesJSX = [<p>Pre pokretanja programa</p>,renderFiles(OSConf.setup.files)];
    }
    if(OSConf.teardown && OSConf.teardown.files){
        teardownFilesJSX = [<p>Nakon završavanja programa</p>,renderFiles(OSConf.teardown.files)];
    }
    let finalJSX = null;

    if(setupFilesJSX !== null){
        finalJSX = [setupFilesJSX];
        if(teardownFilesJSX !== null){
            finalJSX.push(teardownFilesJSX);
        }
    }
    else if(teardownFilesJSX !== null){
        finalJSX = [teardownFilesJSX];
    }
    else{
        return null;
    }
    return (OSConfigDisplayTemplate(
            {buttonText: "Prikaži podatke za fajlove", buttonID: "filesButtonToggler"}, finalJSX
        )
    );
}
function renderFiles(files){
    if(!files){
        return null;
    }
    const pathObj = {"real":"path", "display":"Putanja"};
    const accessObj = {"real":"access", "display":"Prava pristupa"};
    const ownerObj = {"real":"owner", "display":"Vlasnik"};
    const groupObj = {"real":"group", "display":"Grupa"};
    const typeObj = {"real":"type", "display":"Tip fajla"};
    const atimeObj = {"real":"atime", "display":"Vreme pristupa"};
    const mtimeObj = {"real":"mtime", "display":"Vreme promene"};
    const ctimeObj = {"real":"ctime", "display":"Vreme kreiranja"};
    const reducer = (acc, file)=>{
        if(file.hasOwnProperty("path"))  { acc.add(pathObj);}
        if(file.hasOwnProperty("access")){acc.add(accessObj);}
        if(file.hasOwnProperty("owner")) {acc.add(ownerObj);}
        if(file.hasOwnProperty("group")){ acc.add(groupObj);}
        if(file.hasOwnProperty("type")){ acc.add(typeObj);}
        if(file.hasOwnProperty("atime")){ acc.add(atimeObj);}
        if(file.hasOwnProperty("mtime")){ acc.add(mtimeObj);}
        if(file.hasOwnProperty("ctime")){ acc.add(ctimeObj);}
        return acc;
    };
    var fieldsToRender = files.reduce(reducer, new Set());
    fieldsToRender = [...fieldsToRender];
    var filesJSX = mapFilesToJSX(files, fieldsToRender);
    var headerJSX = fieldsToRender.map((f)=>{
        return(<th>{f.display}</th>);
    });
    const JSXToRender =
        <Table bordered>
            <thead>
            <tr>{headerJSX}</tr>
            </thead>
            <tbody>
            {filesJSX}
            </tbody>
        </Table>;
    return( JSXToRender);
}
/*
* produces jsx of format:
* <tr>
    <td>valueOfCorrespondingFieldInHeader</td>
    ...
  </tr>
* */
function mapFilesToJSX(files, fields){
    return files.map((file)=>{
        return(<tr>
            {
                fields.map((field)=>{
                    return(<td>{file[field.real]}</td>)
                })
            }
        </tr>);
    })
}
/******************************************************FLOCKS******************************************************/
function renderFlocksConfig(OSConf) {
    let setupFlocksJSX = null;
    let teardownFlocksJSX = null;
    if(OSConf.setup && OSConf.setup.flocks){
        setupFlocksJSX = [<p>Pre pokretanja programa</p>,renderFlocks(OSConf.setup.flocks)];
    }
    if(OSConf.teardown && OSConf.teardown.flocks){
        teardownFlocksJSX = [<p>Nakon završavanja programa</p>,renderFlocks(OSConf.teardown.flocks)];
    }
    let finalJSX = null;

    if(setupFlocksJSX !== null){
        finalJSX = [setupFlocksJSX];
        if(teardownFlocksJSX !== null){
            finalJSX.push(teardownFlocksJSX);
        }
    }
    else if(teardownFlocksJSX !== null){
        finalJSX = [teardownFlocksJSX];
    }
    else{
        return null;
    }
    return (OSConfigDisplayTemplate(
            {buttonText: "Prikaži podatke za zakljucavanje fajlova", buttonID: "flocksButtonToggler"}, finalJSX
        )
    );
}
function renderFlocks(flocks){
    if(!flocks){
        return null;
    }
    var locksJSX = flocks.map((flock)=>{
        var locksInfo = flock.locks.map((lock)=>{
            return (
                <tr>
                    <td className={"p-1"}>{lock.type}</td>
                    <td className={"p-1"}>{lock.start}</td>
                    <td className={"p-1"}>{lock.length}</td>
                </tr>
            );
        });
        return(
            <tr>
                <td>{flock.fileName}</td>
                <td>
                    <Table>
                        <thead>
                            <th className={"p-1"}>Tip</th>
                            <th className={"p-1"}>Start</th>
                            <th className={"p-1"}>Dužina</th>
                        </thead>
                        <tbody>
                            {locksInfo}
                        </tbody>
                    </Table>
                </td>
            </tr>
        );
    });
    const JSXToRender =
        <Table bordered>
            <thead>
            <tr>
                <td>Naziv fajla</td>
                <td colSpan={"100%"} className={"text-center"}>Ključevi</td>
            </tr>
            </thead>
            <tbody>
            {locksJSX}
            </tbody>
        </Table>;
    return( JSXToRender );
}

/*****************************************************SIGNALS*****************************************************/
function renderSignalsConfig(OSConf) {
    let setupSignalsJSX = null;
    let teardownSignalsJSX = null;
    if(OSConf.setup && OSConf.setup.signals){
        setupSignalsJSX = [<p>Pre pokretanja programa</p>, renderSignals(OSConf.setup.signals)];
    }
    if(OSConf.teardown && OSConf.teardown.signals){
        teardownSignalsJSX = [<p>Nakon završavanja programa</p>, renderSignals(OSConf.teardown.signals)];
    }
    let finalJSX = null;

    if(setupSignalsJSX !== null){
        finalJSX = [setupSignalsJSX];
        if(teardownSignalsJSX !== null){
            finalJSX.push(teardownSignalsJSX);
        }
    }
    else if(teardownSignalsJSX !== null){
        finalJSX = [teardownSignalsJSX];
    }
    else{
        return null;
    }
    return (OSConfigDisplayTemplate(
            {buttonText: "Prikaži podatke za signale", buttonID: "signalsButtonToggler"}, finalJSX
        )
    );
}
function renderSignals(signals){
    if(!signals){
        return null;
    }
    var signalsJSX = signals.map((signal)=>{
        return(<Row> Signal {signal.which} poslat nakon {signal.delay} ms</Row>);
    });
    return(<div className={"container"}>{signalsJSX}</div>);
}
/*******************************************************FIFOS*******************************************************/
function renderFifosConfig(OSConf) {
    let setupFifosJSX = null;
    let teardownFifosJSX = null;
    if(OSConf.setup && OSConf.setup.fifos){
        setupFifosJSX = [<p>Pre pokretanja programa</p>,renderFifos(OSConf.setup.fifos)];
    }
    if(OSConf.teardown && OSConf.teardown.fifos){
        teardownFifosJSX = [<p>Nakon završavanja programa</p>,renderFifos(OSConf.teardown.fifos)];
    }
    let finalJSX = null;

    if(setupFifosJSX !== null){
        finalJSX = [setupFifosJSX];
        if(teardownFifosJSX !== null){
            finalJSX.push(teardownFifosJSX);
        }
    }
    else if(teardownFifosJSX !== null){
        finalJSX = [teardownFifosJSX];
    }
    else{
        return null;
    }
    return (OSConfigDisplayTemplate(
            {buttonText: "Prikaži fifo fajlove", buttonID: "fifosButtonToggler"}, finalJSX
        )
    );
}
function renderFifos(fifos){
    if(!fifos){
        return null;
    }
    var fifoJSX = fifos.map((fifo)=>{
        return(
            <tr>
                <td>{fifo.path}</td>
                <td>{fifo.data}</td>
            </tr>
        );
    });
    return(
        <Table bordered>
            <thead>
            <tr>
                <th>Putanja</th>
                <th>Podaci</th>
            </tr>
            </thead>
            <tbody>
            {fifoJSX}
            </tbody>
        </Table>);
}
function OSConfigDisplayTemplate ({buttonText, buttonID}, JSXToRender){
    return(
        <Col>
            <Row>
                <Button id={buttonID} className={"mb-2"} color={"warning"}>
                    {buttonText}
                </Button>
            </Row>
            <Row>
                <UncontrolledCollapse toggler={buttonID}>
                    {JSXToRender}
                </UncontrolledCollapse>
            </Row>
        </Col>
    );
}
